import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PublicPage from './components/PublicPage';
import WeddingWebsite from './components/WeddingWebsite';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import reportWebVitals from './reportWebVitals';

const path = window.location.pathname;
const isPublicRoute = path.startsWith('/public');
const isWeddingRoute = path.startsWith('/wedding');
const isPrivacy = path === '/privacy';
const isTerms = path === '/terms';

function RootApp() {
  if (isWeddingRoute) return <WeddingWebsite />;
  if (isPrivacy) return <PrivacyPolicy />;
  if (isTerms) return <TermsAndConditions />;
  if (isPublicRoute) return <PublicPage />;
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
